import { useEffect, useState } from 'react';

/**
 * A spot in the admin Header that a page can render a compact control into
 * (via a portal), between the page title and the account area.
 *
 * Used by the Travel "Booking for" bar: once an identity is chosen it collapses
 * to one line, and that line belongs up in the header rather than costing the
 * embedded travel app a full-width row of its own.
 */
export const HEADER_SLOT_ID = 'admin-header-slot';

/** The slot element, or null until the header has mounted it (or on a page without one). */
export function useHeaderSlot() {
  const [slot, setSlot] = useState(null);
  useEffect(() => {
    setSlot(document.getElementById(HEADER_SLOT_ID));
  }, []);
  return slot;
}
